// src/components/ContactCard.jsx
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock } from "react-icons/fa";

export default function ContactCard() {
  return (
    <section className="bg-white py-12 px-6 md:px-12">
      <div className="max-w-4xl mx-auto bg-green-50 p-6 rounded-2xl shadow-lg">
        <h2 className="text-2xl font-bold text-green-700 mb-4">Contact Details</h2>
        <ul className="space-y-4 text-gray-800 text-lg">
          <li className="flex items-start gap-3">
            <FaPhoneAlt className="mt-1 text-green-600" />
            <a href="tel:+918319789552" className="hover:underline">
              +91 83197 89552
            </a>
          </li>
          <li className="flex items-start gap-3">
            <FaEnvelope className="mt-1 text-green-600" />
            <a href="mailto:drnidhimalviya19@gmail.com" className="hover:underline">
              drnidhimalviya19@gmail.com
            </a>
          </li>
          <li className="flex items-start gap-3">
            <FaMapMarkerAlt className="mt-1 text-green-600" />
            <span>
              Shop No- G-3, Udai Nagar, Near Elite Anmol Apartment, Indore
            </span>
          </li>
          <li className="flex items-start gap-3">
            <FaClock className="mt-1 text-green-600" />
            <span>
              <strong>Mon–Sat:</strong> 10 AM – 1 PM, 5 PM – 8 PM<br />
              <strong>Sunday:</strong> 10 AM – 1 PM
            </span>
          </li>
        </ul>
      </div>
    </section>
  );
}
